import { Text, Price } from '@kanda-libs/ks-design-library';

interface ViewComponentProps {
  /**
   * Card title
   */
  title?: string;
  /**
   * Amount
   */
  amount?: string | number;
  /**
   * Text
   */
  classNames?: {
    cardContainer?: string;
    title?: string;
    pounds?: string;
    cents?: string;
    priceWrapper?: string;
  };
  /**
   * Is loading
   */
  isLoading?: boolean;
}

const ViewComponent = ({
  title,
  amount,
  classNames = {},
  isLoading,
}: ViewComponentProps) => (
  <div className={classNames.cardContainer}>
    <Text
      skeletonProps={{
        width: 80,
      }}
      isLoading={isLoading}
      text={title as string}
      className={classNames.title}
    />
    <Price
      amount={amount as number}
      poundsClassName={classNames.pounds}
      centsClassName={classNames.cents}
      wrapperClassName={classNames.priceWrapper}
      isLoading={isLoading}
    />
  </div>
);

ViewComponent.defaultProps = {
  title: '',
  amount: undefined,
  classNames: {},
  isLoading: false,
};

ViewComponent.displayName = 'MoneyCard-view';

export default ViewComponent;
